import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import service from '../service';
import { stableStringify } from '@Utils/searchParams';

/**
 * One page of `GET /v2/fish` (the `fish` search index) for the given JSON:API query. The previous
 * page stays on screen while the next one loads.
 */
export function useFishV2(searchParams: Record<string, string | number>) {
  const key = useMemo(() => stableStringify(searchParams), [searchParams]);

  return useQuery({
    queryKey: ['fishV2', key],
    queryFn: () => service.getFishV2(searchParams),
    placeholderData: (previous) => previous
  });
}
